import React from "react";
import { Box, Button, IconButton } from "@mui/material";
import { PaletaColor } from "../styles/StylesConstantes";
import { AddAPhoto, Delete } from "@mui/icons-material";

function PromocionAddEditImagenComponents({
    editarImagenes,
    previewImages,
    handleFileChange,
    handleDragStart,
    handleDrop,
    handleDragOver,
    handleDeleteImage,
    mode,
    handleApiOrdenarImagenes,
    handleDeleteImageIndex,
    handleApiAgregarImagenes
}) {


    // console.log("previewImages", previewImages);


    // Ordenar las imágenes por `order_column` antes de renderizarlas
    const sortedImages = [...previewImages].sort((a, b) => a.order_column - b.order_column);



    return (
        <Box>
            <input
                type="file"
                accept="image/*"
                multiple
                style={{ display: "none" }}
                id="file-input"
                onChange={handleFileChange}
            />

            {mode !== 'ordenar-eliminar' && (
                <label htmlFor="file-input">
                    <button
                        type="button"
                        className="flex items-center gap-2 rounded-lg bg-[#104063] px-4 py-2 font-semibold text-white transition-colors hover:bg-[#0d3553] mb-4"
                        onClick={() => document.getElementById('file-input').click()}
                    >
                        <AddAPhoto />
                        Agregar Imágenes
                    </button>
                </label>
            )}

            {previewImages.length > 0 && (
                <div
                    className="flex flex-wrap gap-4 overflow-x-auto p-4 bg-gray-100 rounded-lg"
                >
                    {/* {sortedImages.map((img, index) => ( */}
                    {previewImages.map((img, index) => (
                        <div
                            key={index}
                            draggable
                            onDragStart={() => handleDragStart(index)}
                            onDragOver={handleDragOver}
                            onDrop={() => handleDrop(index)}
                            className="relative w-36 h-48 rounded-lg overflow-hidden flex justify-center items-center bg-gray-100 cursor-grab"
                        >
                            <div>
                                <img
                                    // src={img}
                                    //si tiene id el img, es porque tiene una url y debemos usarla
                                    src={img?.id ? img?.url : img}
                                    alt={`Imagen ${index + 1}`}

                                    className="w-full h-full object-cover"
                                />

                                {/*                                
                                <span className="absolute bottom-2 left-2 text-white bg-black bg-opacity-50 px-2 py-1 rounded">
                                    {img?.file_name || "Sin nombre"}
                                </span> */}
                            </div>
                            <IconButton
                                aria-label="delete"
                                // onClick={() => handleDeleteImage(index)}
                                //si tiene id el img, es porque tiene una url y debemos usarla
                                // onClick={() => handleDeleteImage(img?.id ? img : index)}
                                onClick={() => {
                                    if (img?.id) {
                                        handleDeleteImage(img);
                                    } else {
                                        handleDeleteImageIndex(index)
                                    }
                                }}
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    backgroundColor: PaletaColor.BLANCO,
                                }}
                            >
                                <Delete color="error" />
                            </IconButton>
                        </div>
                    ))}
                </div>
            )}



            <div className="flex justify-start gap-3 border-t border-gray-200 mt-6 pt-4">
                {mode !== "view" && (
                    <button type="submit" className="px-6 py-2 bg-[#104063] hover:bg-[#0d3553] text-white rounded-lg font-medium transition-colors"
                        // disabled={loadingGuardar}
                        onClick={() => {
                            if (mode === 'ordenar-eliminar') {
                                handleApiOrdenarImagenes();
                            } else if (mode === 'agregar') {
                                handleApiAgregarImagenes();
                            }
                        }}
                    >
                        {/* {id ? "Guardar cambios" : "Guardar"} */}
                        {false ? "Guardando..." : false ? "Guardar cambios" : "Guardar"}
                    </button>
                )}

                <button type="button" className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                    onClick={() => {
                        window.history.back();
                    }}
                >
                    Cancelar
                </button>
            </div>
        </Box>
    );
}

export default PromocionAddEditImagenComponents;